import { render, staticRenderFns } from "./CheckboxList.vue?vue&type=template&id=0486f07b&scoped=true"
import script from "./CheckboxList.vue?vue&type=script&lang=js"
export * from "./CheckboxList.vue?vue&type=script&lang=js"
import style0 from "./CheckboxList.vue?vue&type=style&index=0&id=0486f07b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0486f07b",
  null
  
)

export default component.exports